import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { AppSettings } from '../enums/app-settings.enum';
import { ActivatedRoute } from '@angular/router';
import { SkuDataService } from '../services/sku-data.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-parental-control-details',
  templateUrl: './parental-control-details.component.html',
  styleUrls: ['./parental-control-details.component.css']
})
export class ParentalControlDetailsComponent implements OnInit {

  sku: any;
  skuId:any;
  productId:any;
  ENV: string = '';
  URLS: any;
  isArabic: boolean = false;
  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private aRoute: ActivatedRoute,
  ) { 
    this.ENV = this.UTS.getENV();
    this.isArabic = this.UTS.getLocaleLanguage().toUpperCase() === 'AR' ? true: false;
  }

  ngOnInit(): void {
    this.getNAVURLs();

    this.aRoute.queryParams.subscribe((p) => {
      if (p && p.skuId) {
        this.getSKUDetails(p.skuId);
        this.skuId = p.skuId;
        this.productId = p.productId;
      }
      if (p && p?.env && p?.env == 'mobile') {
        this.ENV = p?.env;
        this.UTS.setENV(p?.env);
      }
    });
  }

  private getSKUDetails(skuId) {
      this.skuDetailsById(skuId).then((r) => {
        this.sku = { ...this.sku, ...r };
        if(this.sku?.seeMoreDetailsLink){
          this.sku.seeMoreDetailsLink = (this.isArabic ? '/ar' : '/en') + this.sku.seeMoreDetailsLink;
        }
      });
  }
      

  private async skuDetailsById(id: string) {
    const response = await this.SKUDS.getSkuById(id)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

  getNAVURLs() {
    if (this.UTS.getLocaleLanguage()=='ar') {
      this.URLS = {
        APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL
      };
    } else {
      this.URLS = {
        APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL
      };
    }
  }

  onSubscribe(){
    window.location.href = environment.BASE_URL + `/smartHomeConfiguration?productId=${this.productId}&skuId=${this.skuId}&locale=${
                           this.UTS.getLocaleLanguage().toLocaleLowerCase()}`;
  }

}
